export const enum MemberStatus {
  MEMBER = 'org_member',
  ADMIN = 'org_admin',
}

export const emailSeparatorRegex = /[ \n,;]+/;
